import React from "react";
import "./MembershipFeeTable.css";

const MembershipFeeTable = () => {
  return (
    <div>
        <section className="section-council">
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">SUBSCRIPTION FEE</h2>
      <div className="sectionbottom-line"></div>
      </section>
    <div className="membership-fee-container">
      <h1 className="title">Membership Subscription Fee - 2025</h1>
        {/* Download Button */}
        <div className="download-button-container">
          <a href="/files/ASG Subscription Fee - 2025.pdf" download>
            <button className="careo-btn">
              <i className="fas fa-download"></i> Download
            </button>
          </a>
        </div>
      {/* Individual Membership Table */}
      <h2 className="section-title">Individual Membership</h2>
      <table className="fee-table">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Fee Description</th>
            <th>Ghanaians</th>
            <th>Non-Nationals</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>01</td>
            <td>Onetime Registration Fee</td>
            <td>GHS 200</td>
            <td>$ 20</td>
          </tr>
          <tr>
            <td>02</td>
            <td>Annual Membership Subscription – Students</td>
            <td>GHS 350</td>
            <td>$ 50.00</td>
          </tr>
          <tr>
            <td>03</td>
            <td>Annual Membership Subscription – Affiliates</td>
            <td>GHS 650</td>
            <td>$ 100.00</td>
          </tr>
          <tr>
            <td>04</td>
            <td>Annual Membership Subscription – Associates</td>
            <td>GHS 900</td>
            <td>$ 150.00</td>
          </tr>
          <tr>
            <td>05</td>
            <td>Annual Membership Subscription – Fellows</td>
            <td>GHS 1250</td>
            <td>$ 200.00</td>
          </tr>
        </tbody>
      </table>

      {/* Institutional Membership Table */}
      <h2 className="section-title">Institutional Membership</h2>
      <table className="fee-table">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Membership & License Description</th>
            <th>Applicable Fee</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>01</td>
            <td>
              Actuarial Service Provider (ASP) License – Local Consulting
              Practice
            </td>
            <td>GHS 6000.00</td>
          </tr>
          <tr>
            <td>02</td>
            <td>
              Actuarial Service Provider (ASP) License – International
              Consulting Practice
            </td>
            <td>$ 800.00</td>
          </tr>
          <tr>
            <td>03</td>
            <td>
              Actuarial Service Provider (ASP) License – Multinational Insurers
              with Group Level Principal Actuaries
            </td>
            <td>$ 500.00</td>
          </tr>
          <tr>
            <td>04</td>
            <td>
              Additional Principal Actuary Stamp (PAS) – Local/International/
              Multinational Insurers
            </td>
            <td>$ 50.00</td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default MembershipFeeTable;
